export default function Hero() {
  const handleAnchorClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20flowing%20ribbons%20of%20golden%20and%20coral%20light%2C%20soft%20gradients%20suggesting%20film%20reels%20and%20dramatic%20storytelling%2C%20dark%20theater-like%20background%20with%20glowing%20warm%20highlights%2C%20artistic%20and%20elegant%20motion%20blur%20effect%2C%20no%20text%2C%20editorial%20quality%20with%20rich%20textures&width=1600&height=900&seq=hero-bg-jiujiu&orientation=landscape"
          alt="久久影视平台主视觉"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-sm font-medium mb-5 backdrop-blur-sm border border-accent-500/30">
              全网热门电视剧全集一网打尽
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-4">
              久久影视
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-sans font-light text-white/80 mt-2">
                热门电视剧全集免费在线观看
              </span>
            </h1>

            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
              久久影视汇集海量电视剧全集免费在线观看，热门国产剧、韩剧全集秒速加载，无需苦等更新，一次性畅享完整剧情。高清画质搭配流畅播放体验，让你告别卡顿缓冲，轻松沉浸在每一部精彩好剧之中。无论是最新完结的爆款国产剧，还是高分引进的韩剧全集，这里都能找到。
            </p>

            <div className="flex flex-wrap items-center gap-5 justify-center lg:justify-start mb-7">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-green-400"></span>
                <span>每日更新 30+ 剧集</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>覆盖国产 / 韩剧 / 日剧</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-primary-400"></span>
                <span>高清秒播 不卡顿缓冲</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleAnchorClick('#ranking'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleAnchorClick('#index'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white/15 text-white font-medium text-sm hover:bg-white/25 transition-colors backdrop-blur-sm border border-white/20 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-grid-line"></i>
                探索专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20collage%20of%20drama%20posters%20with%20warm%20golden%20and%20coral%20tones%2C%20abstract%20film%20strip%20elements%20blending%20with%20soft%20glowing%20particles%2C%20elegant%20theatrical%20atmosphere%20with%20rich%20shadows%20and%20highlights%2C%20modern%20entertainment%20streaming%20aesthetic%2C%20no%20text%2C%20luxurious%20visual%20texture%20with%20dramatic%20lighting&width=1200&height=1600&seq=hero-visual-jiujiu&orientation=portrait"
                alt="久久影视热门剧集视觉展示"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}